import { render, staticRenderFns } from "./ContractDocumentsTable.vue?vue&type=template&id=84d61ada&scoped=true"
import script from "./ContractDocumentsTable.vue?vue&type=script&lang=js"
export * from "./ContractDocumentsTable.vue?vue&type=script&lang=js"
import style0 from "./ContractDocumentsTable.vue?vue&type=style&index=0&id=84d61ada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d61ada",
  null
  
)

export default component.exports